import React from "react";
import { Target } from "lucide-react";
import { Badge } from "./badge";

export const ScoreBadge = ({ score }: { score: number }) => (
  <div className="absolute bottom-0 flex w-full justify-center">
    <Badge className="absolute -bottom-2 mx-auto" variant="overlay" size="lg">
      <Target className="size-4" />
      {score}
    </Badge>
  </div>
);
